import { createAsyncThunk } from '@reduxjs/toolkit'
import { AppDispatch, RootState } from '../store'
import WebSocketManager from '@/services/websocketManager'
import {
  setConnectionStatus,
  setError,
} from '@/redux/slices/timerWebsocketSlice'

const webSocketManager = WebSocketManager.getInstance()

export const connectTimerWebSocket = createAsyncThunk<
  void,
  { jwtToken: string; roomId: string },
  { dispatch: AppDispatch; state: RootState }
>('websocket/connectTimer', async ({ jwtToken, roomId }, { dispatch }) => {
  try {
    await webSocketManager.connectToTimer(jwtToken, roomId)

    webSocketManager.registerConnectionHandlers('timer', {
      onConnected: () => {
        dispatch(setConnectionStatus(true))
      },
      onDisconnected: () => {
        dispatch(setConnectionStatus(false))
      },
      onError: (error) => {
        dispatch(setError(error.message))
      },
    })

    return Promise.resolve()
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : 'Unknown error connecting to timer WebSocket'
    dispatch(setError(errorMessage))
    return Promise.reject(error)
  }
})

export const disconnectTimerWebSocket = createAsyncThunk<
  void,
  void,
  { dispatch: AppDispatch; state: RootState }
>('websocket/disconnectTimer', async (_, { dispatch }) => {
  try {
    await webSocketManager.disconnect('timer')
    dispatch(setConnectionStatus(false))
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : 'Unknown error disconnecting timer WebSocket'
    dispatch(setError(errorMessage))
  }
})

export const sendTimerMessage = (message: object): boolean => {
  return webSocketManager.sendMessage('timer', message)
}
